import React from "react";

import Heading from "@common/components/Heading/Heading";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import * as MetricDetailsStyled from "main/pages/Release/views/MetricDetails/MetricDetails.styles";
import { MetricKeys, RoutePaths } from "main/router/config/routePaths";
import { generatePath, Link, useSearchParams } from "react-router-dom";

export default function TestingCoverageAboutView() {
  const [searchParams] = useSearchParams();
  const { selectedWorkspace, selectedApp } = useAppSelectionContext();

  const metadataDimensionsPath = generatePath(RoutePaths.RELEASE_METRIC_METADATA_DIMENSIONS, {
    workspaceSlug: selectedWorkspace?.slug ?? null,
    appKey: selectedApp?.key ?? null,
    metricKey: MetricKeys.testingCoverage,
  });

  return (
    <div style={{ padding: "3.2rem 0" }}>
      <MetricDetailsStyled.MetricsCard>
        <Heading
          heading3
          marginBottom={24}
        >
          About
        </Heading>
        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          What it measures
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "How thoroughly your release has been exercised across the device and environment dimensions you care about — OS, device tier, country, locale, or any "
          }
          <Link
            to={{ pathname: metadataDimensionsPath, search: searchParams.toString() }}
            style={{ textDecoration: "underline" }}
          >
            metadata dimension your team turns on
          </Link>
          .
        </Paragraph>

        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          Why it matters
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "A release tested only on the newest iPhone and Chrome desktop will ship bugs you won't see until production. Coverage forces an explicit, measurable answer to: did we hit every combination that matters before shipping?"
          }
        </Paragraph>

        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          How to use it
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "Define dimensions that mirror how your users actually fragment. The score is weighted toward your worst-performing dimension, so one neglected segment can't hide behind strong numbers elsewhere. Route internal testers to whichever category is underexposed."
          }
        </Paragraph>
      </MetricDetailsStyled.MetricsCard>
    </div>
  );
}
